import { crmAxios } from '@/utils/Axios';
import { UPDATE_LOADING_STATE } from '@/constants/mutation-types';

const isEmptyResponse = (data) => {
  if (data == null) return true;
  if (typeof data === 'string') return !data.trim();
  if (typeof data === 'object') return Object.keys(data).length === 0;
  return false;
};

export default async ({ commit }, casInfoId) => {
  commit(UPDATE_LOADING_STATE, true);

  try {
    const { data } = await crmAxios({
      method: 'get',
      url: `/Contact/GetCasInfoByCasInfoId/${casInfoId}`,
      headers: { Accept: 'application/json' },
    });

    if (isEmptyResponse(data)) {
      commit('setCasSuggestion', null);
      return { error: false, empty: true, data: null };
    }

    let parsed = data;

    if (typeof data === 'string') {
      try {
        parsed = JSON.parse(data);
      } catch (err) {
        throw new Error(
          `Failed to parse CAS response for ID ${casInfoId}: ${err.message}`,
        );
      }
    }

    commit('setCasSuggestion', parsed);

    return { data: parsed };
  } finally {
    commit(UPDATE_LOADING_STATE, false);
  }
};